import { useMemo } from 'react';
import { useAuthContext } from 'app/contexts/auth/context';

/**
 * Keycloak realm role that grants platform-wide admin privileges.
 * Defined here so all role checks share a single source of truth.
 */
export const ADMIN_ROLE = 'administrator';

/**
 * Imperative helper for callers that already have a `user` object (e.g.
 * route guards). Prefer the `useIsAdmin` hook inside components.
 */
export const isUserAdmin = (user) => {
  const roles = user?.roles ?? [];
  return roles.some((role) => String(role).toLowerCase() === ADMIN_ROLE);
};

/**
 * Returns true when the authenticated user has the `administrator` role.
 *
 * Use this hook anywhere you need to gate UI on admin privileges. The
 * underlying API endpoints must still enforce authorization server-side
 * via the `RequireAdminRole` middleware.
 */
export const useIsAdmin = () => {
  const { user } = useAuthContext();
  return useMemo(() => isUserAdmin(user), [user]);
};

export default useIsAdmin;
